import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';

const useStyles = makeStyles((theme) => ({
  root: {
      lineHeight: ".75rem" 
  },
  inputCtC : {
    backgroundColor: "transparent !important",
    color: "#3B5158",
    fontSize: "12px",
    borderBottom: "1px solid #3B5158",
    padding: 0,
    height: "14px !important",
    width: "100px"
}
}));

function InputClickToCall(props) {
  const classes = useStyles();

  return (
    <InputBase
    type={"text"}
    id="input-click-to-call"
    classes={{root: classes.root, input: classes.inputCtC}}
    value={props.value}
    onChange={props.onChange}
    inputProps={{ 'aria-label': 'naked', maxLength: 15}}
  />
    )
}


      export {InputClickToCall}